// extracted by css-extract-rspack-plugin
export default {"icon":"o9IQGzv3dlglHov2","first":"YArTvvenfP8Ay_R4","last":"jc9I_d2gvdgFrPHk","link":"Rx5DTaG8Nu4AGfri"};